export const DATE_FORMAT = 'YYYY-MM-DD';
export const PRICING_DATETIME_FORMAT = 'MM/dd/yyyy HH:mm';
export const PRODUCTS_FEEDS_DATETIME_FORMAT = 'dd MMM yyyy HH:mm';
